import { render } from "./BackofficeNavbar.vue?vue&type=template&id=785b1e28"
import script from "./BackofficeNavbar.vue?vue&type=script&lang=js"
export * from "./BackofficeNavbar.vue?vue&type=script&lang=js"

import "./BackofficeNavbar.vue?vue&type=style&index=0&id=785b1e28&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__